/**
 * Partner Form Sidebar
 * Handles the "Become a Partner" form sidebar functionality
 * Only runs on pages with the .become-a-partner class
 */

class PartnerFormSidebar {
  constructor() {
    // Only run on become-a-partner page
    if (!document.querySelector('.become-a-partner')) return;

    this.selectors = {
      triggerButton: '[id*="image_with_text_8fdPRM"] .image-with-text__content .btn',
      formSection: '.become-a-partner .contact-form',
      contactWrapper: '.contact__wrapper',
    };

    this.classes = {
      active: 'active',
      bodyLocked: 'partner-form-open',
    };

    this.elements = this._getElements();
    if (!this.elements.triggerButton || !this.elements.formSection) return;

    this._init();
  }

  _getElements() {
    return {
      triggerButton: document.querySelector(this.selectors.triggerButton),
      formSection: document.querySelector(this.selectors.formSection),
      contactWrapper: document.querySelector(this.selectors.formSection + ' ' + this.selectors.contactWrapper),
    };
  }

  _init() {
    // Create and insert close button
    this._createCloseButton();
    // Setup event listeners
    this._setupEventListeners();
  }

  _createCloseButton() {
    const closeButton = document.createElement('button');
    closeButton.className = 'partner-form-close';
    closeButton.setAttribute('aria-label', 'Close form');
    closeButton.setAttribute('type', 'button');
    closeButton.innerHTML = `
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 8L8 22M8 8L22 22" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    if (this.elements.contactWrapper) {
      this.elements.contactWrapper.style.position = 'relative';
      this.elements.contactWrapper.insertBefore(closeButton, this.elements.contactWrapper.firstChild);
      this.elements.closeButton = closeButton;
    }
  }

  _setupEventListeners() {
    // Open sidebar when trigger button is clicked
    this.elements.triggerButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.open();
    });

    // Close sidebar when close button is clicked
    if (this.elements.closeButton) {
      this.elements.closeButton.addEventListener('click', () => {
        this.close();
      });
    }

    // Close sidebar when clicking on the backdrop
    this.elements.formSection.addEventListener('click', (e) => {
      // Only close if clicking directly on the form section (backdrop area)
      if (e.target === this.elements.formSection) {
        this.close();
      }
    });

    // Close sidebar when ESC key is pressed
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.elements.formSection.classList.contains(this.classes.active)) {
        this.close();
      }
    });
  }

  open() {
    this.elements.formSection.classList.add(this.classes.active);
    document.body.classList.add(this.classes.bodyLocked);
  }

  close() {
    this.elements.formSection.classList.remove(this.classes.active);
    document.body.classList.remove(this.classes.bodyLocked);
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new PartnerFormSidebar();
});

